import React from "react";

export default class Login extends React.Component {
  render() {
    return <div>페이지를 불러오는 중입니다.</div>;
  }
}
